<div *ngIf="templateGroup?.sortedItems && templateGroup.groupRef" class="group">
    <div *ngFor="let sortedItem of templateGroup.sortedItems; let first = first; let last = last">
        <div *ngIf="sortedItem.groups !== undefined; else isItem">
            <templates-group
                [templateGroup]="sortedItem"
                [financialLineItems]="financialLineItems"
                [groupIsFirst]="first"
                [groupIsLast]="last"
                [parentGroup]="parentGroup"
                [templateType]="templateType"
                [languages]="languages"
                (removeFromEquityEvent)="removeFromEquityEvent.emit($event)"
                (removeTemplateGroupEvent)="removeTemplateGroup($event)"
                (addTemplateGroupEvent)="onAddGroupTemplate($event)"
                (onGroupSortingClicked)="moveItem($event.itemToMove, $event.up)"
            >
            </templates-group>
        </div>
        <ng-template #isItem>
            <div [ngClass]="sortedItem.isSubtotal ? 'subtotal' : 'fli'">
                <span *ngIf="sortedItem.isSubtotal">{{ sortedItem.name }}</span>
                <span *ngIf="!sortedItem.isSubtotal">{{ sortedItem.name }}</span>
                <mat-icon (click)="removeGroupItem(sortedItem)">remove_circle_outline</mat-icon>
                <mat-icon *ngIf="!sortedItem.isSubtotal" (click)="addSubFli(sortedItem)">add_circle_outline</mat-icon>
                <mat-icon *ngIf="sortedItem.isSubtotal" (click)="editSubtotal(sortedItem)">mode_edit</mat-icon>
                <mat-icon *ngIf="!last" (click)="moveItem(sortedItem, false)">south</mat-icon>
                <mat-icon *ngIf="!first" (click)="moveItem(sortedItem, true)">north</mat-icon>
                <div
                    *ngFor="
                        let subFli of sortedItem.subFlisAndOfThatItems;
                        let index = index;
                        let first = first;
                        let last = last
                    "
                    class="subFli"
                >
                    <span *ngIf="subFli.isOfThatItem">
                        {{ 'aumico_templates_group_account_mapping_of_that_item_text' | i18next }}</span
                    >
                    <span>{{ subFli.name }}</span>
                    <mat-icon (click)="removeSubFli(index, sortedItem)">remove_circle_outline</mat-icon>
                    <mat-icon (click)="editSubFli(sortedItem, subFli, index)">mode_edit</mat-icon>
                    <mat-icon *ngIf="!last" (click)="moveSubFli(subFli, sortedItem, false)">south</mat-icon>
                    <mat-icon *ngIf="!first" (click)="moveSubFli(subFli, sortedItem, true)">north</mat-icon>
                </div>
            </div>
        </ng-template>
    </div>

    <div class="groupName">
        <span *ngIf="!templateGroup.groupRef.isHiddenGroup">{{ templateGroup.groupRef.title[currentLanguage] }}</span>
        <span *ngIf="templateGroup.groupRef.isHiddenGroup" class="hidden-group">{{
            templateGroup.groupRef.title[currentLanguage]
        }}</span>
        <mat-icon *ngIf="templateGroup.groupRef.isDefault" (click)="updateDefaultGroup(templateGroup.groupRef)"
            >mode_edit</mat-icon
        >
        <mat-icon *ngIf="!templateGroup.groupRef.isDefault" (click)="removeTemplateGroupEvent.emit(templateGroup)">
            remove_circle_outline</mat-icon
        >
        <mat-icon [matMenuTriggerFor]="menu">add_circle_outline</mat-icon>
        <mat-icon *ngIf="!groupIsLast" (click)="moveGroup(templateGroup, false)">south</mat-icon>
        <mat-icon *ngIf="!groupIsFirst" (click)="moveGroup(templateGroup, true)">north</mat-icon>
        <mat-menu #menu="matMenu">
            <button mat-menu-item *ngIf="templateGroup.groupRef.allowGroups" (click)="addTemplateGroups()">
                {{ 'aumico_templates_group_view_add_group' | i18next }}
            </button>
            <button mat-menu-item *ngIf="templateGroup.groupRef.allowItems" (click)="addSubtotal()">
                {{ 'aumico_templates_group_view_add_subtotal' | i18next }}
            </button>
            <button mat-menu-item *ngIf="templateGroup.groupRef.allowItems" (click)="addFinancialLineItems()">
                {{ 'aumico_templates_group_view_add_fli' | i18next }}
            </button>
            <button mat-menu-item *ngIf="templateGroup.groupRef.allowItems" (click)="addHiddenGroup()">
                {{ 'aumico_templates_form_add_hidden_group' | i18next }}
            </button>
        </mat-menu>
    </div>
</div>
